import layout from '@/views/common/layout'
const mallRouter = [
    {
        path: '/mall',
        component: layout,
        children: [
            {
                path: 'bannerList',
                component: () => import('@/views/mall/banner/bannerList'),
                name: 'bannerList',
                meta: { title: 'Banner列表', icon: '', affix: true }
            },
            // {
            //     path: 'keyWordList',
            //     component: () => import('@/views/yd/mall/keyWord/keyWordRecommendList'),
            //     name: 'keyWordList',
            //     meta: { title: '关键字管理', icon: '', affix: true }
            // },
            // {
            //     path: 'editkeyWord',
            //     component: () => import('@/views/yd/mall/keyWord/editkeyWord'),
            //     name: 'editkeyWord',
            //     meta: { title: '关键词详情', icon: '', affix: true }
            // },
            // {
            //     path: 'linkKeyWord',
            //     component: () => import('@/views/yd/mall/keyWord/linkKeyWord'),
            //     name: 'linkKeyWord',
            //     meta: { title: '关键词链接', icon: '', affix: true }
            // },
            // {
            //     path: 'articleList',
            //     component: () => import('@/views/yd/mall/article/articleList'),
            //     name: 'articleList',
            //     meta: { title: '文章维护', icon: '', affix: true }
            // },
            // {
            //     path: 'articleDetail',
            //     component: () => import('@/views/yd/mall/article/articleDetail'),
            //     name: 'articleDetail',
            //     meta: { title: '文章编辑', icon: '', affix: true }
            // },
            // {
            //     path: 'functionAreaList',
            //     component: () => import('@/views/yd/mall/functionArea/functionAreaList'),
            //     name: 'functionAreaList',
            //     meta: { title: '功能区维护列表', icon: '', affix: true }
            // },
            // {
            //     path: 'shopSetList',
            //     component: () => import('@/views/yd/mall/shopSet/shopSetList'),
            //     name: 'functionAreaList',
            //     meta: { title: '店铺导航设置', icon: '', affix: true }
            // },
            {
                path: 'discount',
                component: () => import('@/views/mall/discount/discountList'),
                name: 'discount',
                meta: { title: '限时折扣', icon: '', affix: true }
            },
            {
                path: 'newActivity',
                component: () => import('@/views/mall/discount/newActivity'),
                name: 'newActivity',
                meta: { title: '新建活动', icon: '', affix: true }
            },
            {
                path: 'setGoodsPriceList',
                component: () => import('@/views/mall/discount/setGoodsPriceList'),
                name: 'setGoodsPriceList',
                meta: { title: '设置星级折扣', icon: '', affix: true }
            },
            {
                path: 'setIntegerGoodsPriceList',
                component: () => import('@/views/mall/discount/setIntegerGoodsPriceList'),
                name: 'setIntegerGoodsPriceList',
                meta: { title: '设置规格折扣', icon: '', affix: true }
            },
            // {
            //     path: 'shopStyle',
            //     component: () => import('@/views/yd/sys/shopStyle'),
            //     name: 'shopStyle',
            //     meta: { title: '店铺风格', icon: '', affix: true }
            // },
            {
                path: 'goodsRecommendList',
                component: () => import('@/views/mall/recommendGoods/recommendRuleList'),
                name: 'recommendGoodsList',
                meta: { title: '商品推荐规则列表', icon: '', affix: true }
            },
            {

                path: 'goodsRecommendDetail',
                component: () => import('@/views/mall/recommendGoods/editRecommendRule'),
                name: 'editRecommendRule',
                meta: { title: '商品推荐规则列表', icon: '', affix: true }
            },
        ]
    },
    {
        path: '/banner',
        component: layout,
        children: [
            {
                path: 'bannerEdit',
                component: () => import('@/views/mall/banner/bannerEdit'),
                name: 'bannerEdit',
                meta: { title: 'Banner编辑', icon: '', affix: true }
            },
        ]
    },
    // {
    //     path: '/functionArea',
    //     component: layout,
    //     children: [
    //         {
    //             path: 'functionAreaEdit',
    //             component: () => import('@/views/yd/mall/functionArea/functionAreaEdit'),
    //             name: 'functionAreaEdit',
    //             meta: { title: '功能区编辑', icon: '', affix: true }
    //         },
    //     ]
    // },
    {
        path: '/active',
        component: layout,
        children: [
            {
                path: 'list',
                component: () => import('@/views/mall/active/activePage'),
                name: 'activepage',
                meta: { title: '活动列表', icon: '', affix: true }
            },
            {
                path: 'detail',
                component: () => import('@/views/mall/active/editActive'),
                name: 'editActive',
                meta: { title: '活动列表', icon: '', affix: true }
            }
        ]
    },




]

export default mallRouter



// WEBPACK FOOTER //
// ./src/router/modules/mallRouter.js